//See a list of teams within the chosen league.
//TeamList is a component.  This here is a page that OUTPUTS that list.
//This page is very simple because we outsourced the rendering of
//the list into a separate component (TeamList) to keep things lean.
import React from 'react'
import Leaders from '../../leaders/pages/Leaders'
import Standings from '../../standings/pages/Standings'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import Footer from '../../shared/components/UIElements/Footer'
import './Teams.css'
import ad from '../../images/OfficeSpaceForRent.jpg'
import ad2 from '../../images/Berardinelli.JPG'

const Teams = () => {
	return (
		<div style={{ overflowX: 'hidden' }}>
			{/* <StatsAndStandingsHome /> */}
			<Standings />
			<div
				style={{ marginTop: '3rem', marginBottom: '3rem' }}
				className='imgDiv'
			>
				<a href='mailto:Jenniferfree@murrysvillesportzone.com' target='_blank'>
					<img src={ad} className='statsImg' />
				</a>
			</div>
			<div
				style={{ marginTop: '3rem', marginBottom: '3rem' }}
				className='imgDiv'
			>
				<a
					href='https://www.facebook.com/berardinellischoolofdriving'
					target='_blank'
				>
					<img src={ad2} />
				</a>
			</div>
			<Leaders />
			<Footer />
		</div>
	)
}

export default Teams
